import apiClient from '../api.js';

// Capa de servicios para la asignación de ejecutivo(a)s a personal/usuario del
// CRM (`unicen.crm_*`, wrappeados en `modules/crm` en capas nuevas).
//
// Contrato asumido (backend en capas, `modules/crm`):
// las respuestas de error de estos endpoints exponen el mensaje vía
// `.mensaje` (igual que `/crm-catalogos/*`, y a diferencia de los endpoints
// legacy `/crm/...` con path params separados por coma, que no se usan acá)
// — ver `modules/crm/controllers/manejar-error.js`.
//
//   GET  /crm/ejecutivos?id_sede=
//        -> { data: [{ id_ejecutivo, nombre }] }
//
//   GET  /crm/personal-candidatos-ejecutivo?search=&id_sede=
//        -> { data: [{ id_usuario, unicodigo, nombre_completo, rol_nombre }] }
//        Ya viene filtrado server-side por rol PLATAFORMA/CALLCENTER y
//        `id_sede`; sin `search` devuelve hasta 20 candidatos.
//
//   GET  /crm/usuarios-ejecutivos?id_sede=
//        -> { data: [{ id_usuario_ejecutivo, id_usuario, id_ejecutivo,
//                       paterno, materno, nombres, ejecutivo, estado }] }
//        OJO: el DTO devuelve `paterno`/`materno`/`nombres` por separado
//        (no `nombre_completo`); si se necesita el nombre compuesto hay que
//        armarlo en el frontend.
//
//   POST  /crm/usuarios-ejecutivos
//         body: { id_usuario, id_ejecutivo, id_sede, id_usuario_viejo? }
//         -> { data: <asignación creada> }  (201)
//         409 { mensaje } si ya existe una asignación activa igual
//         (EjecutivoDuplicadoError).
//
//   PUT   /crm/usuarios-ejecutivos/:id
//         body: { id_usuario, id_ejecutivo }
//         -> { data: <asignación actualizada> }
//         409 { mensaje } si la asignación sigue activa (UsuarioAunActivoError).
//
//   PATCH /crm/usuarios-ejecutivos/:id/estado
//         body: { estado: 'ACTIVO' | 'INACTIVO' }
//         -> { data: <asignación con el nuevo estado> }

const resource = '/crm';

const useEjecutivoUsuarioApi = {
  listarEjecutivos(idSede) {
    return apiClient.get(`${resource}/ejecutivos`, { params: { id_sede: idSede } });
  },

  buscarPersonalCandidato(search, idSede) {
    return apiClient.get(`${resource}/personal-candidatos-ejecutivo`, {
      params: { search, id_sede: idSede },
    });
  },

  listarAsignaciones(idSede) {
    return apiClient.get(`${resource}/usuarios-ejecutivos`, { params: { id_sede: idSede } });
  },

  crear(datos) {
    return apiClient.post(`${resource}/usuarios-ejecutivos`, datos);
  },

  actualizar(idUsuarioEjecutivo, datos) {
    return apiClient.put(`${resource}/usuarios-ejecutivos/${idUsuarioEjecutivo}`, datos);
  },

  cambiarEstado(idUsuarioEjecutivo, estado) {
    return apiClient.patch(`${resource}/usuarios-ejecutivos/${idUsuarioEjecutivo}/estado`, { estado });
  },

  // Única excepción en este archivo: pega al endpoint LEGACY (path params
  // separados por coma, mensaje de error en `.message` no `.mensaje`) porque
  // `crm_transferirprospectos` todavía no tiene equivalente en `modules/crm`.
  // Mueve TODOS los prospectos de `idUsuarioOrigen` a `idUsuarioDestino` en la
  // sede dada, reasignando también `prospecto_usuario_ejecutivo` (no solo
  // `prospecto.id_usuario`) -- ver 2026-09-22-crm-transferirprospectos-
  // ejecutivo-vigente.sql.
  transferirProspectos(idUsuarioOrigen, idUsuarioDestino, idSede) {
    return apiClient.post(`${resource}/transferirProspectos/${idUsuarioOrigen},${idUsuarioDestino},${idSede}`);
  },
};

export default useEjecutivoUsuarioApi;
